import { render, staticRenderFns } from "./CheckoutShippingMethods.vue?vue&type=template&id=220fe86b&"
import script from "./CheckoutShippingMethods.vue?vue&type=script&lang=ts&"
export * from "./CheckoutShippingMethods.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutShippingMethods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('220fe86b')) {
      api.createRecord('220fe86b', component.options)
    } else {
      api.reload('220fe86b', component.options)
    }
    module.hot.accept("./CheckoutShippingMethods.vue?vue&type=template&id=220fe86b&", function () {
      api.rerender('220fe86b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/checkout/shipping/CheckoutShippingMethods.vue"
export default component.exports